import type { MailboxInfo } from "owa-client-types";
import type ReminderNotificationPayload from "owa-service/lib/contract/ReminderNotificationPayload";
import { action } from "satcheljs";

export interface REMINDER_NOTIFICATIONActionMessage {
    notification: ReminderNotificationPayload;
    mailboxInfo: MailboxInfo | undefined;
}
const defaultExport: (notification: ReminderNotificationPayload, mailboxInfo?: MailboxInfo) => REMINDER_NOTIFICATIONActionMessage = action("REMINDER_NOTIFICATION", (notification: ReminderNotificationPayload, mailboxInfo?: MailboxInfo): REMINDER_NOTIFICATIONActionMessage => ({
    notification,
    mailboxInfo,
}));
export default defaultExport;
